export interface CompanyResponse {
  id: string;
  recruiterId: string;
  companyName: string;
  companyDomain: string;
  companyLogoUrl: string;
  industry: string;
  companySizeRange: string;
  website: string;
  description: string;
  totalCredits: number;
  gstNumber: string;
  headquartersLocation: string;
  createdAt: string;
  updatedAt: string;
}

export interface CompanyRequest {
  recruiterId: string;
  companyName: string;
  companyDomain: string;
  companyLogoUrl: string;
  industry: string;
  companySizeRange: string;
  website: string;
  description: string;
  totalCredits: number;
  gstNumber: string;
  headquartersLocation: string;
}

export const initialCompanyResponse: CompanyResponse = {
  id: "",
  recruiterId: "",
  companyName: "",
  companyDomain: "",
  companyLogoUrl: "",
  industry: "",
  companySizeRange: "",
  website: "",
  description: "",
  totalCredits: 0,
  gstNumber: "",
  headquartersLocation: "",
  createdAt: "",
  updatedAt: "",
};
